import { Link, Outlet } from "react-router-dom"; 
import logo from '../image/fullob.png';
import { useAuth } from "../context/AuthContext";
import '../style/Layout.css';

function Layout() {
  const { user, logout } = useAuth();

  return (
    <>
   <nav className="nav-header">
 
  <div className="nav-left">
    <img src={logo} alt="Logo" className="nav-logo-img" />
  </div>
  <div className="nav-center">
    <div className="nav-title">Customer Verification</div>

    {user && (
      <div className="nav-links">
        <Link to="/home" className="nav-link">Home</Link>
        <Link to="/usermanagement" className="nav-link">Setting</Link>
      </div>
    )}
  </div>
  {user && (
    <div className="nav-right">
  <button className="btn-logout" onClick={logout}>Logout</button>
</div>  )}
</nav>      <main className="main-content">
        <Outlet />
      </main>

      <footer className="footer">
       ©{new Date().getFullYear()} OromiaBank FaydaNID. All rights reserved.
      </footer>
    </>
  );
}

export default Layout;
